<template>

      <custom-particles></custom-particles>

</template>

<script>
export default {
  name: 'StarBanner',
  data() {
    return {};
  },
};
</script>
